import React from "react";
import { createUseStyles } from "react-jss";

import Lightbox from "../components/Lightbox";

const useStyles = createUseStyles(theme => ({
  buttons: {
    display: "flex",
    "justify-content": "center",
    "flex-wrap": "wrap",
    width: 420,
  },
  hotspotButton: {
    width: "20%",
    "box-sizing": "border-box",
    "text-align": "center",
    opacity: 0.8,
    "transition-property": "opacity",
    "transition-duration": "0.25s",
    "margin-bottom": theme.spacing2,
    "border-width": "1px",
    "border-style": "solid",
    "border-color": "transparent",
    padding: theme.spacing1,
    "&:hover": {
      cursor: "pointer",
      opacity: 1,
      "background-color": "rgba(255, 255, 255, 0.1)",
      "border-color": "rgba(255, 255, 255, 0.5)",
    },
  },
  section: {
    "font-weight": "bold",
  },
  hotspotName: {},
  hotspotImage: {
    width: "80%",
    margin: "0 auto",
  },
}));

const HotspotButton = ({ name, image, onClick, classes }) => (
  <div className={classes.hotspotButton} onClick={onClick}>
    <img src={image} alt={name} className={classes.hotspotImage} />
    <div className={classes.hotspotName}>{name}</div>
  </div>
);

const HotspotTypeLightbox = ({ show, onSelect, onClose }) => {
  const classes = useStyles();

  return (
    <Lightbox show={show} onClose={onClose}>
      <h3>Choose hotspot type</h3>
      <p className={classes.section}>Information</p>
      <div className={classes.buttons}>
        <HotspotButton
          image="/assets/hotspots/info.png"
          classes={classes}
          name="Note"
          onClick={varient => onSelect("note", varient)}
        />
        <HotspotButton
          image="/assets/hotspots/gallery.png"
          classes={classes}
          name="Gallery"
          onClick={varient => onSelect("gallery", varient)}
        />
        <HotspotButton
          image="/assets/hotspots/video.png"
          classes={classes}
          name="Video"
          onClick={varient => onSelect("video", varient)}
        />
        <HotspotButton
          image="/assets/hotspots/audio.png"
          classes={classes}
          name="Audio"
          onClick={varient => onSelect("audio", varient)}
        />
        <HotspotButton
          image="/assets/hotspots/web-link.png"
          classes={classes}
          name="Web"
          onClick={varient => onSelect("web", varient)}
        />
      </div>
      <p className={classes.section}>Navigation</p>
      <div className={classes.buttons}>
        <HotspotButton
          image="/assets/hotspots/direction.png"
          classes={classes}
          name="Link 360"
          onClick={varient => onSelect("link", varient)}
        />
        <HotspotButton
          image="/assets/hotspots/crossfade.png"
          classes={classes}
          name="Crossfade"
          onClick={varient => onSelect("fade", varient)}
        />
        <HotspotButton
          image="/assets/hotspots/elevate-up.png"
          classes={classes}
          name="Ascend"
          onClick={varient => onSelect("elevate-up", varient)}
        />
        <HotspotButton
          image="/assets/hotspots/elevate-down.png"
          classes={classes}
          name="Descend"
          onClick={varient => onSelect("elevate-down", varient)}
        />
        <HotspotButton
          image="/assets/hotspots/poi.png"
          classes={classes}
          name="Point of Interest"
          onClick={varient => onSelect("poi", varient)}
        />
        <HotspotButton
          image="/assets/hotspots/timeline.png"
          classes={classes}
          name="Timeline"
          onClick={varient => onSelect("timeline", varient)}
        />
      </div>
    </Lightbox>
  );
};

export default HotspotTypeLightbox;
